import { render, staticRenderFns } from "./ColumnCart.vue?vue&type=template&id=5051fce0"
import script from "./ColumnCart.vue?vue&type=script&lang=js"
export * from "./ColumnCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports